import AccessibilityCardsSection from "./AccessibilityCardsSection";
import HeroSection from "./HeroSection";
import { Box, Button, Grid, Typography } from "@mui/material";
import AccessibleMainSection from "./AccessibleMainSection";
import SubscribeSection from "../HomeScreen/SubscribeSection";
const AccessibilityScreen = () => {
  return (
    <>
      <Box>
        <HeroSection />
      </Box>
      <Box>
        <AccessibilityCardsSection />
      </Box>
           <Box sx={{backgroundColor:"white"}}>
        < AccessibleMainSection />
      </Box>
      {/* <Box>
            <SubscribeSection/>
        </Box> */}
    </>
  );
};
export default AccessibilityScreen;
